"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var react_fontawesome_1 = require("@fortawesome/react-fontawesome");
var free_solid_svg_icons_1 = require("@fortawesome/free-solid-svg-icons");
var react_i18next_1 = require("react-i18next");
var react_dnd_1 = require("react-dnd");
var MediaLibrary_module_css_1 = __importDefault(require("./MediaLibrary.module.css"));
var react_dnd_html5_backend_1 = require("react-dnd-html5-backend");
var Breadcrumb = function (_a) {
    var breadcrumb = _a.breadcrumb, fetchFolderContents = _a.fetchFolderContents, handleMoveMultipleMediaToFolder = _a.handleMoveMultipleMediaToFolder, handleMoveMultipleFoldersToFolder = _a.handleMoveMultipleFoldersToFolder, currentFolderId = _a.currentFolderId, media = _a.media, folders = _a.folders;
    var t = (0, react_i18next_1.useTranslation)().t;
    return (react_1.default.createElement("div", { className: MediaLibrary_module_css_1.default["breadcrumb-container"], "data-cy": "breadcrumbContainer" },
        react_1.default.createElement("span", { className: MediaLibrary_module_css_1.default["breadcrumb-span"], "data-cy": "breadcrumbHome" },
            react_1.default.createElement(BreadcrumbItem, { id: 0, name: t("Home"), fetchFolderContents: fetchFolderContents, handleMoveMultipleMediaToFolder: handleMoveMultipleMediaToFolder, handleMoveMultipleFoldersToFolder: handleMoveMultipleFoldersToFolder, currentFolderId: currentFolderId, media: media, folders: folders, isHome: true, isCurrent: breadcrumb.length === 1 }),
            breadcrumb.length > 1 && (react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: free_solid_svg_icons_1.faAngleRight, className: MediaLibrary_module_css_1.default["angle-icon"] }))),
        breadcrumb.slice(1).map(function (crumb, index) { return (react_1.default.createElement("span", { key: index, className: MediaLibrary_module_css_1.default["breadcrumb-span"], "data-cy": "breadcrumbItem" },
            react_1.default.createElement(BreadcrumbItem, { id: crumb.id, name: crumb.name, fetchFolderContents: fetchFolderContents, handleMoveMultipleMediaToFolder: handleMoveMultipleMediaToFolder, handleMoveMultipleFoldersToFolder: handleMoveMultipleFoldersToFolder, currentFolderId: currentFolderId, media: media, folders: folders, isHome: false, isCurrent: index === breadcrumb.length - 2 }),
            index < breadcrumb.length - 2 && (react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: free_solid_svg_icons_1.faAngleRight, className: MediaLibrary_module_css_1.default["angle-icon"] })))); })));
};
var BreadcrumbItem = function (_a) {
    var id = _a.id, name = _a.name, fetchFolderContents = _a.fetchFolderContents, handleMoveMultipleMediaToFolder = _a.handleMoveMultipleMediaToFolder, handleMoveMultipleFoldersToFolder = _a.handleMoveMultipleFoldersToFolder, currentFolderId = _a.currentFolderId, media = _a.media, folders = _a.folders, isHome = _a.isHome, isCurrent = _a.isCurrent;
    var _b = (0, react_dnd_1.useDrop)({
        accept: [react_dnd_html5_backend_1.NativeTypes.FILE, "MEDIA", "FOLDER"],
        drop: function (item, monitor) {
            if (id === currentFolderId)
                return;
            var targetFolderId = id;
            var itemType = monitor.getItemType();
            var normalizeId = function (item, collection) { return collection.find(function (m) { return m.id === item.id || m.uuid === item.id; }); };
            var draggedMedia = itemType === "MEDIA" && item.id ? [normalizeId(item, media)] : [];
            var draggedFolders = itemType === "FOLDER" && item.id ? [normalizeId(item, folders)].filter(function (f) { return f && f.id !== targetFolderId; }) : [];
            var selectedMedia = (item.selectedMediaIds && item.selectedMediaIds.length > 0)
                ? item.selectedMediaIds.map(function (id) { return normalizeId({ id: id }, media); }).filter(function (m) { return m; })
                : draggedMedia;
            var selectedFolders = (item.selectedFolderIds && item.selectedFolderIds.length > 0)
                ? item.selectedFolderIds.map(function (id) { return normalizeId({ id: id }, folders); }).filter(function (f) { return f && f.id !== targetFolderId; })
                : draggedFolders;
            if (selectedMedia.length > 0) {
                handleMoveMultipleMediaToFolder(selectedMedia, targetFolderId);
            }
            if (selectedFolders.length > 0) {
                handleMoveMultipleFoldersToFolder(selectedFolders, targetFolderId);
            }
            localStorage.removeItem("RaStore.mediaLibrary.selectedIds");
        },
        collect: function (monitor) { return ({
            isOver: monitor.isOver(),
            canDrop: monitor.canDrop(),
        }); },
    }), isOver = _b[0].isOver, drop = _b[1];
    return (react_1.default.createElement("a", { href: "#", onClick: function (e) {
            e.preventDefault();
            fetchFolderContents(id, name);
        }, ref: drop, style: {
            color: "var(--info-color)",
            textDecoration: "none",
            display: "flex",
            alignItems: "center",
            opacity: isCurrent ? 1 : 0.5,
            outline: isOver ? "2px solid var(--primary-color)" : "none",
            borderRadius: "5px",
            padding: "0 5px",
        }, "data-cy": isHome ? "breadcrumbHome" : "breadcrumbLink" },
        isHome && react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: free_solid_svg_icons_1.faHouse, style: { marginRight: "8px", marginTop: "-3px" } }),
        name));
};
exports.default = Breadcrumb;
